const { httpAuth } = require('@/utils/axios');
const _ = require('lodash');

const fetchTeamListData = async (match) => {
  const homeId = _.get(match, "homeTeam._id");
  const awayId = _.get(match, "awayTeam._id");
  try {
    const seRes = await httpAuth.get(`/assemble/api/v1/live/matches/${match._id}/competition-settings`);
    const htRes = await httpAuth.get(`/assemble/api/v1/live/teamlists/matches/${match._id}/teams/${homeId}`);
    const atRes = await httpAuth.get(`/assemble/api/v1/live/teamlists/matches/${match._id}/teams/${awayId}`);
    const compRes = await httpAuth.get(`/assemble/api/v1/live/competitions/${match.competition._id}`);
    const positions = _.sortBy(seRes.data.data, 'order')
    const homeTeamList = htRes.data.data;
    const awayTeamList = atRes.data.data;
    const laddertemplate = compRes ? _.get(compRes, 'data.data.laddertemplate') : {};
    return {
      laddertemplate,
      positions,
      homeTeamList,
      awayTeamList,
      homeData: _.map(positions, position => {
        const player = _.find(_.get(homeTeamList, "players"), t => _.get(t, "position.number") === position.number);
        return player || _.assign({}, { position });
      }),
      homeNPData: _.get(homeTeamList, "nonplayers", []),
      awayData: _.map(positions, position => {
        const player = _.find(_.get(awayTeamList, "players"),t => _.get(t, "position.number") === position.number);
        return player || _.assign({}, { position });
      }),
      awayNPData: _.get(awayTeamList, "nonplayers", [])
    };
  } catch (e) {
    throw new Error(_.get(e, 'response.data.message', false))
  }
}


const fetchMatchEventData = async (match) => {
  const homeId = _.get(match, "homeTeam._id");
  const awayId = _.get(match, "awayTeam._id");
  const htRes = await httpAuth.get(`/assemble/api/v1/live/teamlists/matches/${match._id}/teams/${homeId}`);
  const atRes = await httpAuth.get(`/assemble/api/v1/live/teamlists/matches/${match._id}/teams/${awayId}`);
  const homeTeamList = htRes.data.data;
  const awayTeamList = atRes.data.data;
  return {
    homeTeamList,
    awayTeamList,
  };
}

module.exports = {
  fetchTeamListData,
  fetchMatchEventData,
}